import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';

// Context Providers
import { AuthProvider } from './context/AuthContext';
import { CartProvider } from './context/CartContext';
import { LocationProvider } from './context/LocationContext';

// Components
import MaintenanceMode from './components/MaintenanceMode';
import Header from './components/layout/Header';
import Footer from './components/layout/Footer';
import ScrollToTop from './components/ScrollToTop';
import WhatsAppWidget from './components/WhatsAppWidget';
import PromoPopup from './components/PromoPopup';

// Pages
import Home from './pages/Home';
import Products from './pages/Products';
import ProductDetail from './pages/ProductDetail';
// MODO CATÁLOGO: Imports de carrito/compras comentados
// import Cart from './pages/Cart';
// import Checkout from './pages/Checkout';
import Login from './pages/Login';
import Register from './pages/Register';
import Profile from './pages/Profile';
// import MyOrders from './pages/MyOrders';
// import OrderDetails from './pages/OrderDetails';
// import Wishlist from './pages/Wishlist';
// import PaymentSuccess from './pages/payment/PaymentSuccess';
// import PaymentFailure from './pages/payment/PaymentFailure';
// import PaymentPending from './pages/payment/PaymentPending';
// import ReservationSuccess from './pages/ReservationSuccess';
import PrivacyPolicy from './pages/PrivacyPolicy';
import FAQ from './pages/FAQ';
import ReturnsPolicy from './pages/ReturnsPolicy';
import TermsConditions from './pages/TermsConditions';
import Contact from './pages/Contact';
import About from './pages/About';
import PaymentMethods from './pages/PaymentMethods';

const App = () => {
  const isMaintenanceMode = import.meta.env.VITE_MAINTENANCE_MODE === 'true';

  // Si está en modo mantenimiento, mostrar componente de mantenimiento
  if (isMaintenanceMode) {
    return <MaintenanceMode />;
  }

  return (
    <Router>
      <ScrollToTop />
      <AuthProvider>
        <CartProvider>
          <LocationProvider>
            <div className="min-h-screen flex flex-col">
              <Header />
              <main className="flex-1">
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/productos" element={<Products />} />
                  <Route path="/producto/:id" element={<ProductDetail />} />
                  {/* MODO CATÁLOGO: Rutas de carrito/compras comentadas */}
                  {/* <Route path="/carrito" element={<Cart />} /> */}
                  {/* <Route path="/checkout" element={<Checkout />} /> */}
                  <Route path="/login" element={<Login />} />
                  <Route path="/register" element={<Register />} />

                  {/* User Routes */}
                  <Route path="/perfil" element={<Profile />} />
                  {/* <Route path="/mis-ordenes" element={<MyOrders />} /> */}
                  {/* <Route path="/mis-ordenes/:id" element={<OrderDetails />} /> */}
                  {/* <Route path="/favoritos" element={<Wishlist />} /> */}

                  {/* MODO CATÁLOGO: Rutas de reserva/pago comentadas */}
                  {/* <Route path="/reserva-exitosa" element={<ReservationSuccess />} /> */}
                  {/* <Route path="/checkout/success" element={<PaymentSuccess />} /> */}
                  {/* <Route path="/checkout/failure" element={<PaymentFailure />} /> */}
                  {/* <Route path="/checkout/pending" element={<PaymentPending />} /> */}
                  {/* <Route path="/payment/success" element={<PaymentSuccess />} /> */}
                  {/* <Route path="/payment/failure" element={<PaymentFailure />} /> */}
                  {/* <Route path="/payment/pending" element={<PaymentPending />} /> */}

                  {/* Rutas adicionales */}
                  <Route path="/categorias" element={<Products />} />
                  <Route path="/promociones" element={<Products />} />
                  <Route path="/privacidad" element={<PrivacyPolicy />} />
                  <Route path="/preguntas-frecuentes" element={<FAQ />} />
                  <Route path="/cambios-devoluciones" element={<ReturnsPolicy />} />
                  <Route path="/terminos-condiciones" element={<TermsConditions />} />
                  <Route path="/contacto" element={<Contact />} />
                  <Route path="/nosotros" element={<About />} />
                  <Route path="/medios-de-pago" element={<PaymentMethods />} />

                  {/* 404 */}
                  <Route path="*" element={
                    <div className="min-h-screen flex items-center justify-center bg-gray-50">
                      <div className="text-center">
                        <h1 className="text-6xl font-bold text-[#2d3c5d] mb-4">404</h1>
                        <p className="text-xl text-gray-600 mb-6">Página no encontrada</p>
                        <a href="/" className="inline-block px-6 py-3 bg-[#2d3c5d] text-white rounded-lg font-semibold hover:bg-[#1f2a3d] transition">
                          Volver al inicio
                        </a>
                      </div>
                    </div>
                  } />
                </Routes>
              </main>
              <Footer />
              <WhatsAppWidget />
              <PromoPopup />
            </div>

            {/* Toast notifications */}
            <Toaster
              position="top-right"
              toastOptions={{
                duration: 3000,
                style: {
                  background: '#2d3c5d',
                  color: '#fff',
                },
                success: {
                  style: {
                    background: '#10b981',
                  },
                },
                error: {
                  style: {
                    background: '#ef4444',
                  },
                },
              }}
            />
          </LocationProvider>
        </CartProvider>
      </AuthProvider>
    </Router>
  );
};

export default App;
